import logo from "assets/images/integrations/omniletter_logo.png";
import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { UsernamePasswordSetup } from "../../components/UsernamePasswordSetup/UsernamePasswordSetup";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { OmniletterIntegrationSettings } from "./types";

type OmniletterConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShop = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShop"
  ]) as string;

  return {
    integrationList: state
      .getIn([
        "customerBackendDashboard",
        "shops",
        selectedShop,
        "integrations",
        "data",
        IntegrationType.OMNILETTER
      ])
      ?.toJS() as OmniletterIntegrationSettings[] | undefined
  };
};

const connector = connect(mapStateToProps);

type OmniletterConnectViewComponentProps = OmniletterConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const OmniletterConnectViewComponent = (props: OmniletterConnectViewComponentProps) => {
  const { connectingType, onStartConnecting, onStopConnecting, integrationList } = props;

  const isConnected = useMemo(
    () =>
      integrationList?.some((integration) => {
        return integration.auth && integration.auth.username;
      }) || false,
    [integrationList]
  );

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.OMNILETTER && (
        <UsernamePasswordSetup
          authKeyVisible={false}
          integrationType={IntegrationType.OMNILETTER}
          onFinish={onStopConnecting}
        />
      )}
      <AvailableIntegrationCardHeader image={logo} text="Omniletter" />
      <AvailableIntegrationCardExplanationWrapper>
        <FormattedMessage
          id="containers.Integrations.ListOfApps.Shared.Short.Explanation"
          defaultMessage="Connect your {tool} account with uptain. Then new newsletter subscribers can be added to your account."
          values={{ tool: "Omniletter" }}
        />
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={connectingType !== undefined}
        onConnect={useCallback(
          () => onStartConnecting(IntegrationType.OMNILETTER),
          [onStartConnecting]
        )}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const OmniletterConnectView = connector(OmniletterConnectViewComponent);
